import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES, MODULE_IDS } from "../../constants/enums";


const ZoneList = Loadable(
	lazy(() =>
		import("./ZoneList").then(({ ZoneList }) => ({
			default: ZoneList,
		}))
	)
);

export const zoneRoutes = [
    {
        path: "/zone-list",
        exact: true,
        element: (
            <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ZONE]}>
                <ZoneList />
            </AuthorizedRoute>
        ),
    },
   
];
